// src/keycloak.js
import Keycloak from 'keycloak-js';

let keycloakInstance = null;

export function initKeycloak() {
  if (!keycloakInstance) {
    const kcOptions = {
      realm: process.env.VUE_APP_KEYCLOAK_REALM,
      url: process.env.VUE_APP_KEYCLOAK_URL,
      clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
      // You can remove these if you don't use them in Keycloak configuration
      "ssl-required": "external",
      resource: process.env.VUE_APP_KEYCLOAK_RESOURCE,
      "verify-token-audience": true,
      "use-resource-role-mappings": true,
      "confidential-port": 0,
      "policy-enforcer": {},
    };
    keycloakInstance = new Keycloak(kcOptions);
  }
  return keycloakInstance;
}

export function getKeycloak() {
  if (!keycloakInstance) {
      return null;
  }
  return keycloakInstance;
}


export function removeKeycloack() { 
  keycloakInstance = null;
}